import React from 'react';
import SvgIcon from './SvgIcon';

const CheckMarkFull = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M2.667 12l6.666 6.667L22.061 5.333"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

CheckMarkFull.displayName = 'CheckMarkFullIcon';

export default CheckMarkFull;
